"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIDE_BY_SIDE_NUM_CHILDREN = exports.asSideBySide = exports.SideBySidePlaceholderIndex = exports.DragGridColumns = exports.AllowedPercentageValues = exports.SideBySideColumnSize = exports.SideBySideAlignment = exports.SideBySideWidth = exports.SideBySideOrder = void 0;
var Common_1 = require("./Common");
var SideBySideOrder;
(function (SideBySideOrder) {
    SideBySideOrder["Normal"] = "normal";
    SideBySideOrder["Reverse"] = "reverse";
})(SideBySideOrder = exports.SideBySideOrder || (exports.SideBySideOrder = {}));
var SideBySideWidth;
(function (SideBySideWidth) {
    SideBySideWidth["Content"] = "content";
    SideBySideWidth["Wide"] = "wide";
    SideBySideWidth["Full"] = "full";
    SideBySideWidth["Normal"] = "normal";
})(SideBySideWidth = exports.SideBySideWidth || (exports.SideBySideWidth = {}));
var SideBySideAlignment;
(function (SideBySideAlignment) {
    SideBySideAlignment["Normal"] = "normal";
    SideBySideAlignment["Center"] = "center";
})(SideBySideAlignment = exports.SideBySideAlignment || (exports.SideBySideAlignment = {}));
var SideBySideColumnSize;
(function (SideBySideColumnSize) {
    SideBySideColumnSize[SideBySideColumnSize["OneQuarter"] = 25] = "OneQuarter";
    SideBySideColumnSize[SideBySideColumnSize["OneHalf"] = 50] = "OneHalf";
    SideBySideColumnSize[SideBySideColumnSize["ThreeQuarters"] = 75] = "ThreeQuarters";
})(SideBySideColumnSize = exports.SideBySideColumnSize || (exports.SideBySideColumnSize = {}));
exports.AllowedPercentageValues = [
    SideBySideColumnSize.OneQuarter,
    SideBySideColumnSize.OneHalf,
    SideBySideColumnSize.ThreeQuarters,
];
exports.DragGridColumns = [
    SideBySideWidth.Full,
    SideBySideWidth.Wide,
    SideBySideWidth.Content,
    SideBySideWidth.Wide,
    SideBySideWidth.Full,
];
var SideBySidePlaceholderIndex;
(function (SideBySidePlaceholderIndex) {
    SideBySidePlaceholderIndex[SideBySidePlaceholderIndex["Column1"] = 1] = "Column1";
    SideBySidePlaceholderIndex[SideBySidePlaceholderIndex["Column2"] = 2] = "Column2";
})(SideBySidePlaceholderIndex = exports.SideBySidePlaceholderIndex || (exports.SideBySidePlaceholderIndex = {}));
function asSideBySide(node) {
    return (0, Common_1.as)(Common_1.BlockType.SideBySide, node);
}
exports.asSideBySide = asSideBySide;
exports.SIDE_BY_SIDE_NUM_CHILDREN = 3;
